import { JSX, ReactNode } from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface Props {
  children: ReactNode;
  maxWidth?: number;
  sx?: SxProps<Theme>;
}

export default function ContentCard({
  children,
  maxWidth = 560,
  sx,
}: Props): JSX.Element {
  return (
    <Box
      sx={{
        width: { xs: '100%', md: maxWidth },
        bgcolor: { xs: 'transparent', md: 'background.paper' },
        borderRadius: { xs: 0, md: '20px' },
        p: { xs: '24px 20px', md: '40px 44px' },
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 2, md: 3 },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
